<template>

</template>

<script>
export default {
	name: 'CCdone',
	data () {
		return {
	
		}
	},
	methods:{

	},
	created(){
	},
	watch:{
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/CCdone.vue